export const getParamAsBoolean = (param: any): boolean => {
    return (
        (typeof param === 'string' && param === 'true') ||
        (typeof param !== 'string' && !!param)
    );
};
